import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from "react";
import { showAlertModal } from "@/components/AlertModal";
import "./index.scss";

var header = _jsx("header", __assign({
  className: "temporary-chat-disabled__header"
}, {
  children: "\u63D0\u793A"
}), void 0);

var footer = _jsx("p", __assign({
  className: "temporary-chat-disabled__text"
}, {
  children: "\u4F7F\u7528APP\u626B\u7801\u6DFB\u52A0\u4ED6\u4E3A\u597D\u53CB"
}), void 0);

export function showTemporaryChatDisabledAlert(userQrCodeUrl, message) {
  var QRCode = /*#__PURE__*/React.lazy(function () {
    return import(
    /* webpackChunkName: "qrcodereact" */
    "qrcode.react");
  });

  var inner = _jsxs("div", __assign({
    className: "temporary-chat-disabled"
  }, {
    children: [header, _jsxs("p", __assign({
      className: "temporary-chat-disabled__tip"
    }, {
      children: [_jsx("span", {
        className: "icon temporary-chat-disabled__icon"
      }, void 0), message]
    }), void 0), _jsx("div", __assign({
      className: "temporary-chat-disabled__img"
    }, {
      children: _jsxs(Suspense, __assign({
        fallback: _jsx("div", {
          children: "..."
        }, void 0)
      }, {
        children: [_jsx(QRCode, {
          value: userQrCodeUrl,
          size: 120
        }, void 0), ","]
      }), void 0)
    }), void 0), footer]
  }), void 0);

  showAlertModal(inner);
}